import { gql } from "apollo-boost";

export const GET_ISSUING_STATE_QUERY = gql`
  query issuingStateQuery {
    getUserIssuingStatus {
      accountId
      cardId
      status
      onboardingLink
    }
  }
`;

export const GET_ISSUING_CARD_STATUS_QUERY = gql`
  query {
    card: getIssuingCard{
      status
      cardholder {
        name
        billing_address {
          street
          city
          state
          zip
        }
      }
    }  
  }
`;

export const UPDATE_ISSUING_CARD_STATUS = gql`
  mutation ($status: String!) {
    card: updateIssuingCardStatus(status: $status) {
      status
    }  
  }
`;

export const GET_ISSUING_TRANSACTIONS_QUERY = gql`
query {
  pending: getUserIssuingTransactions(type: "pending") {
    transactions {
      id
      merchant
      category
      amount
      date
      merchantCity
      merchantCountry
      merchantCountry
      merchantZip
      type
    }
    nextToken
  }
  settled: getUserIssuingTransactions(type: "settled") {
    transactions {
      id
      merchant
      category
      amount
      date
      merchantCity
      merchantCountry
      merchantCountry
      merchantZip
      type
    }
    nextToken
  }
}
`;

export const GET_ISSUING_TRANSACTIONS_NEXT = gql`
query ($type: String!, $nextToken: String!){
  data: getUserIssuingTransactions(type: $type, nextToken: $nextToken) {
    transactions {
      id
      merchant
      category
      amount
      date
      merchantCity
      merchantCountry
      merchantCountry
      merchantZip
      type
    }
    nextToken
  }
}
`;

export const CREATE_ISSUING_ACCOUNT_QUERY = gql`
  mutation createIssuingAccount {
    createUserIssuingAccount {
      status
      onboardingLink
    }
  }
`;

export const SUBMIT_CARDHOLDER_TERMS_QUERY = gql`
  mutation {
    createUserIssuingCardHolder {
      status
    }
  }
`;

export const GET_ISSUING_BALANCES_QUERY = gql`
  query issuingBalancesQuery {
    getIssuingBalances {
      available
    }
  }
`;

export const GET_CARD_EPHEMERAL_KEY_SECRET_QUERY = gql`
  query cardEphemeralKeySecretQuery($nonce: String!) {
    getCardEphemeralKeySecret(nonce: $nonce) {
      secret
    }
  }
`;

export const GET_PUSH_FUNDING_ADDRESSES_QUERY = gql`
  query PushFundingAddresses {
    getStripePushFundingAddresses {
      aba {
        account_number
        bank_name
        routing_number
      }
      supported_networks
    }
  }
`;

export const GET_ISSUING_CARD_DETAILS_QUERY = gql`
  query getIssuingCard {
    getIssuingCard {
      type
      status
      exp_month
      exp_year
      last4
      cardholder {
        type
        status
        name
        phone_number
        billing_address {
          street
          city
          state
          zip
        }
      }
    }
  }
`;
